import React, { useEffect } from 'react';
import './Landing.css';

const Landing = ({ onNavigate, session, onSignOut }) => {
  useEffect(() => {
    const element = document.getElementById('destinations-count');
    if (!element) return;

    const target = 218;
    const increment = target / 100;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        element.textContent = target.toLocaleString();
        clearInterval(timer);
      } else {
        element.textContent = Math.floor(current).toLocaleString();
      }
    }, 20);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="landing">
      <nav className="nav">
        <div className="nav-container">
          <span className="logo">✈️ AspireAI</span>
          <ul className="nav-links">
            {session ? (
              <li><button type="button" onClick={onSignOut}>Sign Out</button></li>
            ) : (
              <li><button type="button" onClick={() => onNavigate('auth')}>Sign In</button></li>
            )}
            <li><button type="button" onClick={() => window.location.hash = 'assessment'} className="cta-nav">Start Your Journey</button></li>
          </ul>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1>Transform Your Life Through AI-Powered Travel</h1>
            <p>Discover transformative experiences tailored to your personal growth goals, matched by AI analysis of your assessment answers against a curated destination database.</p>

            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number" id="destinations-count">0</span>
                <span className="stat-label">AI-Curated Destinations</span>
              </div>
            </div>

            <div className="hero-cta">
              <button className="btn-primary" onClick={() => window.location.hash = 'assessment'}>Start Your Assessment</button>
            </div>
          </div>

          <div className="travel-visual">
            <div className="travel-card">
              <div className="transformation-score">9.2</div>
              <h3>🏔️ Mindful Trekking in Nepal</h3>
              <p>Perfect for building resilience and spiritual connection. AI-matched based on your growth goals.</p>
            </div>
            <div className="travel-card">
              <div className="transformation-score">8.7</div>
              <h3>🎋 Cultural Immersion in Kyoto</h3>
              <p>Develop mindfulness and cultural intelligence through traditional practices and ceremonies.</p>
            </div>
            <div className="travel-card">
              <div className="transformation-score">9.5</div>
              <h3>🌊 Solo Adventure in Patagonia</h3>
              <p>Ultimate self-discovery journey for building confidence and connecting with nature.</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <a href="/privacy-policy.html">Privacy Policy</a>
        <span aria-hidden="true">·</span>
        <a href="/terms-of-service.html">Terms of Service</a>
      </footer>
    </div>
  );
};

export default Landing;
